import { getApiBaseUrl } from '../config/api';

export type DataAccessRequestStatus = 'PENDING_MFA' | 'QUEUED' | 'FULFILLED' | 'DENIED';

export interface DataAccessRequestRow {
  id: string;
  userId: string;
  requestType: string;
  status: DataAccessRequestStatus;
  mfaVerifiedAt: string | null;
  createdAt: string;
  user?: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    role: string;
  };
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export const dataAccessAdminService = {
  async listQueue(): Promise<DataAccessRequestRow[]> {
    const res = await fetch(`${getApiBaseUrl()}/admin/data-access-requests/queue`, {
      headers: authHeaders(),
    });
    if (!res.ok) throw new Error('Failed to load data access queue');
    const body = await res.json();
    return body.requests;
  },

  async fulfill(id: string, fulfillmentNotes?: string): Promise<DataAccessRequestRow> {
    const res = await fetch(`${getApiBaseUrl()}/admin/data-access-requests/${id}/fulfill`, {
      method: 'PATCH',
      headers: authHeaders(),
      body: JSON.stringify({ fulfillmentNotes }),
    });
    if (!res.ok) throw new Error('Failed to fulfill request');
    const body = await res.json();
    return body.request;
  },

  async deny(id: string, denialReason: string): Promise<DataAccessRequestRow> {
    const res = await fetch(`${getApiBaseUrl()}/admin/data-access-requests/${id}/deny`, {
      method: 'PATCH',
      headers: authHeaders(),
      body: JSON.stringify({ denialReason }),
    });
    if (!res.ok) throw new Error('Failed to deny request');
    const body = await res.json();
    return body.request;
  },
};
